<template>
	<div class="blog">
		<section class="front__intro">
			<div class="welcome-text" data-aos="fade-up" data-aos-duration="1000">
				<span class="small-text">Vi deler våre tanker</span>
				<h1 class="big-text">Nyheter, inspirasjon og faglig påfyll</h1>
			</div>
		</section>

		<post-list :post-template-id="12" :limit="20">
			<template v-slot:success="s">
				<section class="section section-nopadding news-section">
					<div class="row clearfix flexwrapper">
						<div class="news-item flexitem" v-for="post in s.posts.data" :key="post.id">
							<div class="news-wrapper">
								<router-link :to="post.url">
									<img :src="post.values.default_featuredimage" class="news-img"
										:alt="post.values.default_headline" />
								</router-link>
								<div class="news-text">
									<h3>
										<router-link :to="post.url" class="news-headinglink">
											{{post.values.default_title}}
										</router-link>
									</h3>
									<p class="news-ingress">{{post.values.default_ingress}}</p>
								</div>
							</div>
						</div>
					</div>
				</section>
			</template>
		</post-list>
	</div>
</template>

<script>
	import Vue from 'vue';
	import componentMixin from '@/utils/componentMixin';

	export default Vue.extend({
		mixins: [componentMixin],
	});
</script>

<style lang="scss" scoped>

</style>